import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ClientErrorLoggerService } from 'analytics-logging-lib';

export const analyticsLoggingInterceptor: HttpInterceptorFn = (req, next) => {
  const errorLogger = inject(ClientErrorLoggerService);
  const startTime = Date.now();

  if (req.url.includes('/api/analytics/') || req.url.includes('/api/admin/analytics/')) {
    return next(req);
  }

  return next(req).pipe(
    tap(() => {
      const duration = Date.now() - startTime;
      if (duration > 3000) {
        errorLogger.logSlowApiCall(req.url, duration, req.method).subscribe();
      }
    }),
    catchError((error) => {
      const duration = Date.now() - startTime;
      errorLogger.logHttpError(req.url, req.method, error.status ?? 0, error, duration).subscribe();
      return throwError(() => error);
    })
  );
};
